const styles = ['green', 'gray', 'blue', 'purple', 'yellow', 'red'].flatMap((color) => [
	{ bg: `${color}.500`, color: 'white' },
	{ bg: `${color}.50`, color: 'gray.900' },
]);

export const defaultStyle = {
	bg: 'gray.50',
	color: 'gray.900',
};

export const getStyleFromName = (name: string) => {
	const index =
		[...name].reduce((acc, curr) => {
			return acc + curr.charCodeAt(0);
		}, 0) % styles.length;

	return styles[index] || defaultStyle;
};
